module.exports = __webpack_public_path__ + "static/media/product-onoiwa-mx-detail.088f00e8.png";